// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectReloadHistoryMessage } from '@shared/utils/DirectMessages/DirectMessagesImport';
import { HistoryTypeConverter } from '@shared/utils/History/HistoryTypeConverter';
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
export class HistoricalDataMessageProcessor extends MessageProcessorBase {
    constructor(parentDecoder) {
        super();
        this.decoder = parentDecoder;
    }
    decode(fieldSet) {
        const message = new DirectReloadHistoryMessage();
        message.instrumentTradableID = fieldSet.GetValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID);
        message.instrumentId = fieldSet.GetValue(FieldsFactory.FIELD_INSTRUMENT_ID);
        message.routeID = fieldSet.GetValue(FieldsFactory.FIELD_ROUTE_ID);
        message.historyPeriod = fieldSet.GetValue(FieldsFactory.FIELD_HISTORY_PERIOD_TYPE);
        message.barsType = HistoryTypeConverter.GetLocalHistoryType(fieldSet.GetValue(FieldsFactory.FIELD_BARS_TYPE));
        return [message];
    }
}
